import { React, models, kea, history, resources, selectores, componentToRx, Route, match, withRouter } from "app/main/std";
import { observeResource } from "kea-resource";
type Entity = models.Rol;
import { columnas } from "./columns";
const resource = resources.Rol;
const observable = observeResource(resources.Rol.query);
export class RolList extends React.PureComponent {
    onBorrar = async (x: Entity) => {
        if (await kea.yesno("¿Borrar Rol?", x.Nombre)) {
            await resource.delete(x.IdRegistro!);
        }
    }

    onEdit = (x: Entity) => history.go("/catalogos/Rol/" + x.IdRegistro);
    onAgregar = () => history.go("/catalogos/Rol/new");
    onRegresar = () => history.go("/catalogos");

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Roles" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <kea.Grid2 columnas={cols} cookieKey={"RolListCookieKey"} items={observable} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/roles/list/list.tsx